import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const para = (): void => {
  const paraBgs = document.querySelectorAll('.c-para-bg');
  const paraAnimConts = document.querySelectorAll('.c-anim-cont');
  paraBgs.forEach((paraBg) => {
    gsap.to(paraBg.querySelector('.c-para-bg__bg'), {
      top: '0%',
      scrollTrigger: {
        trigger: paraBg,
        start: 'top 100%',
        end: 'bottom 0%',
        scrub: true,
      },
    });
  });
  paraAnimConts.forEach((paraAnimCont) => {});

  const paras = document.querySelectorAll('[data-depth]');
  paras.forEach((para) => {
    if (!para) return;
    const depth = parseFloat(para.getAttribute('data-depth') || '0');
    const start = para.getAttribute('data-start') || 'top bottom';
    gsap.fromTo(
      para,
      {
        y: depth * -25,
      },
      {
        y: depth * 25,
        scrollTrigger: {
          trigger: para.parentElement,
          start: start,
          end: 'bottom top',
          scrub: 1,
        },
      }
    );
  });

  const paraVideos = document.querySelectorAll('.p-top-functions-item__img video');
  paraVideos.forEach((paraVideo) => {
    let isPlay = false;
    window.addEventListener('scroll', () => {
      const rect = paraVideo.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        if (!isPlay) {
          (paraVideo as HTMLVideoElement).currentTime = 0;
          (paraVideo as HTMLVideoElement).play();
          isPlay = true;
        }
      } else {
        if (isPlay) {
          (paraVideo as HTMLVideoElement).pause();
          isPlay = false;
        }
      }
    });
  });

  const paraVideos2 = document.querySelectorAll('.p-top-functions-item-2__img video');
  paraVideos2.forEach((paraVideo) => {
    let isPlay = false;
    window.addEventListener('scroll', () => {
      const rect = paraVideo.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        if (!isPlay) {
          (paraVideo as HTMLVideoElement).currentTime = 0;
          (paraVideo as HTMLVideoElement).play();
          isPlay = true;
        }
      } else {
        if (isPlay) {
          (paraVideo as HTMLVideoElement).pause();
          isPlay = false;
        }
      }
    });
  });
};
